module.exports = __webpack_public_path__ + "img/naravut_s.248e5e12.webp";